// src/components/treinamento/formularios/evidenciaUtils.js
// =======================================================================
// A regra "pergunta 'Não' exige foto e observação" — do lado da TELA
// -----------------------------------------------------------------------
// ESPELHO da regra do servidor (server/treinamento/formularios/
// evidencia-obrigatoria.js), que é a trava de verdade. Aqui ela existe para o
// auditor descobrir o que falta ANTES de enviar, e para a tela saber o que
// destacar em vermelho — não para autorizar nada.
// =======================================================================

// Teto por pergunta: 1 obrigatória + até 2 extras (mesmo do BSV e da Manutenção).
export const MAX_FOTOS_PERGUNTA = 3;

export const ehNegativa = (valor) => String(valor || '').trim() === 'Não';

/**
 * O que ainda falta para poder enviar.
 * @returns [{ pergunta, faltaFoto, faltaObservacao }] — vazio = pode enviar.
 */
export function pendenciasDeEvidencia(respostas, observacoes, evidencias) {
  const pendencias = [];
  for (const chave of Object.keys(respostas || {})) {
    if (!ehNegativa(respostas[chave])) continue;
    const fotos = (evidencias?.[chave] || []).filter((u) => u && String(u).trim());
    const faltaFoto = fotos.length === 0;
    const faltaObservacao = String(observacoes?.[chave] || '').trim() === '';
    if (faltaFoto || faltaObservacao) pendencias.push({ pergunta: chave, faltaFoto, faltaObservacao });
  }
  return pendencias;
}

/** Mensagem de uma linha, nomeando as perguntas (num formulário de 43 itens,
 *  "faltam evidências" deixa o auditor caçando o campo). */
export function mensagemDePendencias(pendencias) {
  if (!pendencias?.length) return null;
  const partes = pendencias.slice(0, 8).map((p) => {
    const oQue = p.faltaFoto && p.faltaObservacao ? 'foto e observação'
      : p.faltaFoto ? 'foto' : 'observação';
    return `${p.pergunta} (${oQue})`;
  });
  const resto = pendencias.length > partes.length ? ` e mais ${pendencias.length - partes.length}` : '';
  return `Toda pergunta respondida "Não" exige foto e observação.\n\nFalta: ${partes.join(', ')}${resto}.`;
}

/** Achata o estado da tela no formato que o servidor recebe: [{pergunta, url}]. */
export function montarEvidencias(evidencias) {
  const lista = [];
  for (const [pergunta, urls] of Object.entries(evidencias || {})) {
    (urls || []).forEach((url) => {
      if (url && String(url).trim()) lista.push({ pergunta, url });
    });
  }
  return lista;
}

/** Rola até a pergunta pendente e a destaca — é o que evita a caçada ao campo. */
export function irParaPergunta(chave) {
  const el = document.querySelector(`[data-pergunta="${chave}"]`);
  if (!el) return;
  el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  el.style.transition = 'box-shadow 0.3s';
  el.style.boxShadow = '0 0 0 3px #fca5a5';
  setTimeout(() => { el.style.boxShadow = 'none'; }, 2000);
}

/** Chave da sessão de preenchimento: agrupa as fotos de UMA visita na pasta do
 *  SharePoint. Existe porque o ID da visita só nasce no envio — e sem ela duas
 *  visitas da mesma loja no mesmo dia misturariam arquivos na mesma pasta. */
export function novaChaveSessao() {
  return Math.random().toString(36).slice(2, 8) + Date.now().toString(36).slice(-4);
}
